<template>
    <div v-if="!isLoading" class="blogs-page wrapper">
        <div class="columns is-tablet">
            <div class="column is-9-tablet is-12-mobile is-9-widescreen is-9-fullhd">
                <div class="confirm-unsubscribe-email">
                    <form @submit.prevent="handleConfirmUnsubscribeEmail" v-if="!confirmUnsubscribeEmail">
                        <p class="label">Are you sure you want to unsubscribe from the following emails:</p>
                        <ul class="list-unsubscribe">
                            <li :data-type="content.type_email || ''" @click="toggleClass($event)" v-for="content in contents" :key="content.id">
                                <span>{{ content.subj }}</span>
                                <span>{{ distfreq[content.distfreq] }}</span>
                            </li>
                            <li data-type="auto_blog" @click="toggleClass($event)">
                                <span>Blog posts</span>
                                <span>bi-weekly</span>
                            </li>
                            <li data-type="auto_blog" @click="toggleClass($event)">
                                <span>Ad hoc updates on various topics (what's new, partnerships …)</span>
                                <span>ad-hoc / monthly</span>
                            </li>
                        </ul>
                        <button class="btn-confirm button is-primary mt-2" type="submit"
                            :disabled="isDisableConfirmBtn">CONFIRM</button>
                    </form>
                    <span v-else>
                        {{ confirmUnsubscribeEmail }}
                    </span>
                </div>
            </div>
            <div ref="subRight_before"
                class="column is-12-mobile is-3-tablet is-3-widescreen is-3-fullhd">
                <div class="banner-on-top" ref="subRight">
                    <AdsGoogle />
                </div>
            </div>
        </div>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
</template>
<script>
import bannerMixin from "@/mixins/bannerMixin";
import Preloader from "@/components/Preloader";
import axios from "axios";
import AdsGoogle from '@/components/AdsGoogle.vue';

export default {
    name: 'ConfirmUnsubscribeEmail',
    components: { Preloader, AdsGoogle },
    mixins: [bannerMixin],
    data: function () {
        return {
            isLoading: false,
            contents: [],
            confirmUnsubscribeEmail: null,
            distfreq: {
                '1': 'daily',
                '2': 'weekly',
                '3': 'monthly'
            }
        }
    },
    methods: {
        getListContent() {
            this.isLoading = true;
            axios.get("/automatedemails").then(response => {
                if (response)
                    this.contents = response.data
            }).finally(() => {
                this.isLoading = false;
            })
        },
        handleConfirmUnsubscribeEmail() {
            this.isLoading = true;
            const code = this.$route.params.id;
            let listItems = document.querySelectorAll('.list-unsubscribe li.active');
            let auto = {}; 
            listItems.forEach((li) => {
                if (li.dataset.type) {
                    auto[li.dataset.type] = true
                }
            });
            axios.post(`/unsubscribe-email/${code}`, auto).then(response => {
                if (response) {
                    this.confirmUnsubscribeEmail = response.data;
                }
            }).finally(() => {
                this.isLoading = false;
            })
        },
        toggleClass(event){
            if (event.target.nodeName == 'SPAN') {
                event.target.closest('li').classList.toggle('active')
            } else {
                event.target.classList.toggle('active')
            }
            
        }
    },
    mounted() {
        this.getListContent();
    },
    metaInfo() {
        return {
            title: "Confirm Unsubscribe link in an automated email | Pickafund",
            meta: [
                {
                    name: "description",
                    content:
                        "Confirm Unsubscribe link in an automated email.",
                },
                { property: "og:title", content: "Confirm Unsubscribe link in an automated email | Pickafund" },
            ],
        };
    },
}
</script>
<style scoped lang="scss">
li span:nth-child(2) {
    float: right;
}
li span:nth-child(1){
    max-width: calc(100% - 140px);
    display: inline-flex;
}
li {
    cursor: pointer;
}
li.active {
    list-style-type: disc;
}
.confirm-unsubscribe-email {
    background-color: #fff;
    padding: 30px 80px;
    border: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    form {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    ul {
        list-style-type: circle;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin: 10px 20px;
    }

    .btn-confirm {
        align-self: center;
    }
}
</style>